"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonFloating = function ButtonFloating(_ref) {
  var disabled = _ref.disabled,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["disabled", "icon", "iconPosition", "children"]);

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    disabled: disabled,
    sx: {
      cursor: disabled ? 'default' : 'pointer',
      textTransform: 'uppercase',
      display: 'inline-block',
      borderRadius: children ? 'xLarge' : '50%',
      fontFamily: 'body',
      fontSize: 1,
      fontWeight: 'bold',
      letterSpacing: 'loose',
      lineHeight: 'normal',
      outline: 'none',
      boxShadow: 5,
      color: 'text',
      bg: 'secondary',
      p: 3,
      transition: function transition(theme) {
        return "box-shadow 300ms " + theme.easing.quickToSlow;
      },
      ':hover': {
        boxShadow: 6
      },
      ':active': {
        bg: 'secondaryDark'
      },
      ':disabled': {
        boxShadow: 'none',
        color: 'textDisabled',
        bg: 'blackDisabled'
      }
    }
  }), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, children && iconPosition === 'right' && (0, _themeUi.jsx)(_themeUi.Box, null, children), icon && (0, _themeUi.jsx)(_themeUi.Box, {
    sx: {
      mr: children && iconPosition === 'left' ? 3 : 0,
      ml: children && iconPosition === 'right' ? 3 : 0
    }
  }, (0, _themeUi.jsx)(_Icon["default"], _extends({
    icon: icon,
    size: 2,
    sx: {
      color: 'inherit'
    }
  }, disabled && {
    color: 'textDisabled'
  }))), children && iconPosition === 'left' && (0, _themeUi.jsx)(_themeUi.Box, null, children)));
};

ButtonFloating.propTypes = {
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].func,
  iconPosition: _propTypes["default"].oneOf(['left', 'right']),
  children: _propTypes["default"].node
};
ButtonFloating.defaultProps = {
  disabled: false,
  icon: null,
  iconPosition: 'left'
};
var _default = ButtonFloating;
exports["default"] = _default;